import Survival from './index.vue'

export default [
  {
    path: '/disease-risk-stratification',
    alias: '/survival',
    name: 'DiseaseRiskStratification',
    component: Survival
  }
]
